import { FilterToolbarItem, FilterToolbarItemId } from 'src/components/Filters';
import { PosEnumSelect } from 'src/core/POS/PosSelect';
import { ContentId } from 'src/utils/constants/contentId';
import { PURCHASE_PAYMENT_STATUS_TO_CID } from 'src/utils/constants/contentIdMaps';
import { PurchasePaymentStatus } from 'src/WebApiController';

type PurchasePaymentStatusFilter = {
  paymentStatus: PurchasePaymentStatus | null;
};

export const usePurchasePaymentStatusFilters = <
  TFilter extends PurchasePaymentStatusFilter,
>({
  query,
  setQuery,
}: {
  query: TFilter;
  setQuery: (query: TFilter) => void;
}): FilterToolbarItem => {
  return {
    filterId: 'paymentStatus' as FilterToolbarItemId,
    labelContentId: ContentId.PaymentState,
    filterQueryKeys: ['paymentStatus'] as FilterToolbarItemId[],
    filterItem: (
      <PosEnumSelect
        style={{ width: '100%' }}
        value={query.paymentStatus}
        placeholderText={ContentId.AllPaymentStates}
        enableEmptySelection
        onChange={(paymentStatus) => {
          if (paymentStatus !== query.paymentStatus) {
            setQuery({
              ...query,
              paymentStatus: paymentStatus,
            });
          }
        }}
        valueOptionsContent={PURCHASE_PAYMENT_STATUS_TO_CID}
      />
    ),
  };
};
